import { useTranslation } from 'react-i18next';
import { Select } from '@hotjar/webapp/components/Select';
import type { Site } from '@hotjar/site';

interface SiteSelectorProps {
  selectedId?: number;
  onChange: (event: React.FormEvent<HTMLSelectElement>) => void;
  sites: Array<Site>;
}

export const SiteSelector = ({ selectedId, onChange, sites }: SiteSelectorProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Select size="l" value={selectedId} onChange={onChange} aria-label="site-selector">
      {!selectedId && <option value="">{t('common:site-settings.no-site-selected')}</option>}
      {sites.map((site) => (
        <option key={site.id} value={site.id}>
          {site.name}
        </option>
      ))}
    </Select>
  );
};
